// import { useState } from "react";
import { Col, Container, Row, Card, ListGroup } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.png";

export const Contact = () => {
  return (
    <section className="contact" id="connect">
      <Container>
        <Row>
          <Col md={6}>
            <img src={contactImg} alt="Contact" className="contact-image"></img>
            <Card className="mb-4" border="dark">
              <Card.Body>
                {/* <Card.Title> */}
                <Card.Header>
                  <h2>Feel free to reach out if you want to talk about:</h2>
                </Card.Header>
                {/* </Card.Title> */}
                <Card.Text>
                  <ListGroup variant="flush">
                    <ListGroup.Item variant="info">Tech</ListGroup.Item>
                    <ListGroup.Item variant="info">
                      {" "}
                      <a
                        href="https://www.chaiandconversation.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Learning Persian
                      </a>
                    </ListGroup.Item>
                    <ListGroup.Item variant="info">
                      Job Opportunities
                    </ListGroup.Item>
                    <ListGroup.Item variant="info">
                      Anything Else!
                    </ListGroup.Item>
                  </ListGroup>
                </Card.Text>
              </Card.Body>
            </Card>
            <Card>
              <Card.Body>
                {/* <Card.Title> */}
                <Card.Header>
                  <h2>Check out: </h2>
                </Card.Header>
                {/* </Card.Title> */}
                <Card.Text>
                  <ListGroup variant="flush">
                    {/* <ListGroup.Item variant="info">
                      Work From Home Essentials
                    </ListGroup.Item> */}
                    <ListGroup.Item variant="info">
                      <a
                        href="https://shireneboyd.hashnode.dev/"
                        alt="Shirene's blog dashboard"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        My Blog Posts
                      </a>
                    </ListGroup.Item>
                    <ListGroup.Item variant="info">
                      <a
                        href="https://www.youtube.com/watch?v=GJmXyC4DpVo"
                        alt="All the Twitters youtube clip"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Street Cred
                      </a>&#128521;
                    </ListGroup.Item>
                  </ListGroup>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Row>
              <div className="iframe-container">
                <iframe
                  title="Contact Form"
                  src="https://docs.google.com/forms/d/e/1FAIpQLSdu7SawQq3_DzOE2Wr_sr-EsPbLnL7umYEsceYOymex03kT6A/viewform?embedded=true"
                  frameborder="0"
                  marginheight="0"
                  marginwidth="0"
                >
                  Loading…
                </iframe>
              </div>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
